module.exports = __webpack_public_path__ + "img/nexultra-sunscreen-active-icon.266c98a6.svg";